import * as React from 'react'

import { useIsMobile } from '@/hooks/use-mobile'

// Phones held in landscape exceed the width breakpoint (48rem) and would be
// treated as desktop, yet they are still touch devices with very little
// height (tablets are not: iPad's short side is >= 744px). Surfaces that must
// never render the desktop experience on a phone (e.g. bottom-sheet dialogs)
// use this instead of useIsMobile.
const PHONE_LANDSCAPE_QUERY = '(pointer: coarse) and (max-height: 500px)'

export function useIsPhoneViewport(): boolean {
  const isMobile = useIsMobile()
  const [isPhoneLandscape, setIsPhoneLandscape] = React.useState(false)

  React.useEffect(() => {
    const mql = window.matchMedia(PHONE_LANDSCAPE_QUERY)
    const onChange = () => setIsPhoneLandscape(mql.matches)
    mql.addEventListener('change', onChange)
    setIsPhoneLandscape(mql.matches)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return isMobile || isPhoneLandscape
}
